import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useRef } from "react";
import CartItem from "./CartItem";

const CartScroll = ({ cart }: { cart: any[] }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollBy = (offset: number) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: offset, behavior: "smooth" });
    }
  };

  if (cart.length === 0) {
    return (
      <div className='text-center text-gray-700'>لا يوجد منتجات في السلة</div>
    );
  }

  return (
    <div className='relative'>
        {cart.length >= 3 && (
            <>
      <button
        disabled={cart.length === 0}
        className={`${
          cart.length === 0
            ? "opacity-50 cursor-not-allowed"
            : "absolute left-0 top-1/2 z-10 -translate-y-1/2 bg-white shadow p-2 rounded-full"
        }`}
        onClick={() => scrollBy(-300)}
        type='button'
      >
        <IoChevronBack className='text-xl text-gray-600' />
      </button>

      <button
        disabled={cart.length === 0}
        className={`${
          cart.length === 0
            ? "opacity-50 cursor-not-allowed"
            : "absolute right-0 top-1/2 z-10 -translate-y-1/2 bg-white shadow p-2 rounded-full"
        }`}
        onClick={() => scrollBy(300)}
        type='button'
      >
        <IoChevronForward className='text-xl text-gray-600' />
      </button>
      </>
      )}

      <div
        ref={scrollRef}
        className='flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-4 px-10 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100'
        style={{ direction: "rtl" }}
      >
        {cart.map((item) => (
          <div
            key={item.id}
            className='snap-start flex-shrink-0 w-[80%] sm:w-[48%] md:w-[30%]'
          >
            <CartItem item={item} />
          </div>
        ))}
      </div>
    </div>
  );
};
export default CartScroll;